import { render, staticRenderFns } from "./SettingsPresentation.vue?vue&type=template&id=6f23a9fc&scoped=true"
import script from "./SettingsPresentation.vue?vue&type=script&lang=js"
export * from "./SettingsPresentation.vue?vue&type=script&lang=js"
import style0 from "./SettingsPresentation.vue?vue&type=style&index=0&id=6f23a9fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f23a9fc",
  null
  
)

export default component.exports